/** MM-DD-YYYY → YYYY-MM-DD for Firestore ordering */
export function practiceDateToSortDate(practiceDate) {
  const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec((practiceDate || '').trim());
  if (!m) return '';
  const [, mm, dd, yyyy] = m;
  const mi = parseInt(mm, 10);
  const di = parseInt(dd, 10);
  if (mi < 1 || mi > 12 || di < 1 || di > 31) return '';
  return `${yyyy}-${mm}-${dd}`;
}

export function isValidPracticeDate(s) {
  return !!practiceDateToSortDate(s);
}

/** MM-DD-YYYY → value for `<input type="date">` (YYYY-MM-DD) */
export function practiceDateToHtmlDateValue(practiceDate) {
  return practiceDateToSortDate(practiceDate) || '';
}

/** `<input type="date">` value → MM-DD-YYYY for Firestore */
export function htmlDateValueToPracticeDate(htmlDate) {
  const s = (htmlDate || '').trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return '';
  const [, yyyy, mm, dd] = m;
  const mi = parseInt(mm, 10);
  const di = parseInt(dd, 10);
  if (mi < 1 || mi > 12 || di < 1 || di > 31) return '';
  return `${mm}-${dd}-${yyyy}`;
}

export function youtubeIdFromUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const u = url.trim();
  const watch = u.match(/youtube\.com\/watch[^#]*?[?&]v=([^&?#]+)/);
  if (watch) return watch[1];
  const short = u.match(/youtu\.be\/([^?&#]+)/);
  if (short) return short[1];
  const embed = u.match(/youtube\.com\/embed\/([^?&#]+)/);
  if (embed) return embed[1];
  return '';
}

export function localSortDateToday() {
  const n = new Date();
  const y = n.getFullYear();
  const mo = String(n.getMonth() + 1).padStart(2, '0');
  const d = String(n.getDate()).padStart(2, '0');
  return `${y}-${mo}-${d}`;
}
